import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, type Qualified} from '@packages/systems/wfdl-Qualified';

import {type ExpressionElement} from '@packages/systems/wfdl-ast';

export const boundaryElementType: Qualified<Component.ComponentName> = qualify(
  Plugins.name('Commerce'),
  Component.name('CommerceDownloadsItem')
);

export const createBindingContextBoundary = (
  element: ExpressionElement
): Readonly<{
  boundaryType: 'startAt';
  boundaryElementId: string;
  boundaryContextVariant: 'List';
}> => {
  return {
    boundaryType: 'startAt',
    boundaryElementId: element.id,
    boundaryContextVariant: 'List',
  };
};
